import { queries } from "@corpuscomplete/core/zero";
import { FoodCollection } from "@corpuscomplete/core/nutrition/food-collection";
import { Food } from "@corpuscomplete/core/nutrition/food";
import { Zero } from "@rocicorp/zero";
import { useQuery } from "@corpuscomplete/zero-data-transformer/react";

type FoodType = Food.Type;
type ContentFilter = { foodType?: FoodType };

export namespace FoodCollectionUI {
  export function resolveManagedCollectionId({
    requestedCollectionId,
    collections,
    foodType,
  }: {
    requestedCollectionId?: string;
    collections: Array<{
      id: string;
      allowedFoodTypes: Food.Type[] | null | undefined;
      defaultForUserId?: string | null;
    }>;
    foodType: FoodType;
  }): string | undefined {
    const matchingCollections = collections.filter((collection) =>
      FoodCollection.allowsFoodType(collection, foodType),
    );

    if (requestedCollectionId) {
      const requestedCollection = matchingCollections.find(
        (collection) => collection.id === requestedCollectionId,
      );

      if (requestedCollection) {
        return requestedCollectionId;
      }
    }

    const defaultCollection = matchingCollections.find(
      (collection) => collection.defaultForUserId != null,
    );

    if (defaultCollection) {
      return defaultCollection.id;
    }

    return matchingCollections[0]?.id;
  }

  export function useForContents(args?: ContentFilter) {
    const [collections] = useQuery(queries.foodCollection.forContents());
    const foodType = args?.foodType;
    return foodType
      ? collections.filter((collection) => FoodCollection.allowsFoodType(collection, foodType))
      : collections;
  }

  export function useForContentManagement(args?: ContentFilter) {
    const [collections] = useQuery(queries.foodCollection.forContentManagement());
    const foodType = args?.foodType;
    return foodType
      ? collections.filter((collection) => FoodCollection.allowsFoodType(collection, foodType))
      : collections;
  }

  export function useLoading() {
    const [, details] = useQuery(queries.foodCollection.forContents());
    return { loading: details.type === "unknown" };
  }

  export function preload(zero: Zero) {
    void zero.run(queries.foodCollection.forContents());
    void zero.run(queries.foodCollection.forContentManagement());
  }
}
